import { render, staticRenderFns } from "./404.vue?vue&type=template&id=c711fa8c&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=c711fa8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c711fa8c",
  null
  
)

/* custom blocks */
import block0 from "./404.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports